export enum CancellationPolicyType {
    NoRefund = 'noRefund',
    FullRefund = 'fullRefund',
    PartialRefund = 'partialRefund',
}
